import React, { memo } from 'react'
import { Box, ListItem, ListItemButton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeadMenuItemProps } from '../model/types'
import { useHeadMenuItem } from '../hooks/useHeadMenuItem'
import { brandedTokens } from '@/theme/tokens'

export const HeadMenuItem: React.FC<HeadMenuItemProps> = memo((props) => {
    const { handleClick } = useHeadMenuItem(props)

    const {
        label,
        icon,
        title,
        toggleIcon,
        actionIcon,
        isOpen,
        onClickIcon,
        active = false,
        className,
        sx,
    } = props

    return (
        <ListItem disablePadding className={className}>
            <ListItemButton
                onClick={actionIcon ? undefined : handleClick}
                className={active ? 'active' : ''}
                disableRipple={!!actionIcon}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    py: 1.15,
                    fontWeight: 600,
                    cursor: actionIcon ? 'default' : 'pointer',
                    '&.active, &.active:hover': {
                        bgcolor: brandedTokens.variables.secondaryScale[30],
                        fontWeight: 600,
                    },
                    '&:hover': {
                        bgcolor: 'transparent',
                    },
                    
                }}
            >
                {/* Left main icon */}
                <Box
                    sx={{
                        mr: 0.625,
                        height: 24,
                        width: 24,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <FontAwesomeIcon icon={icon} />
                </Box>

                {label}

                {/* Optional right icon */}
                {toggleIcon && (
                    <FontAwesomeIcon
                        icon={isOpen ? toggleIcon.open : toggleIcon.closed}
                        className="dropArrow"
                        style={{ marginLeft: 'auto' }}
                    />
                )}
                {actionIcon && (
                    <FontAwesomeIcon
                        icon={actionIcon}
                        title={title}
                        onClick={onClickIcon}
                        style={{
                            cursor: 'pointer',
                            marginRight: 5,
                            marginLeft: 'auto',
                            float: 'right',
                        }}
                        className={'addDossier'}
                    />
                )}
            </ListItemButton>
        </ListItem>
    )
})

HeadMenuItem.displayName = 'HeadMenuItem'
